
import React, { useState } from 'react';

import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";

import { Alert, AlertTitle, Typography } from "@mui/material";
import Paper from "@mui/material/Paper";

import FormLabel from "@mui/material/FormLabel";

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import {
    LocalizationProvider,
    DatePicker,
} from "@mui/x-date-pickers";

import { useSelector } from "react-redux";


import { Grid, TextField } from "@mui/material";

import moment from "moment";
import { TimePicker } from "@mui/x-date-pickers";


function OrderDateTime({ pickupTimeTypeHandler, pickupTimeHandler, selectedDateHandler }) {
    const [pickupTimeType, setPickupTimeType] = useState("now");
    const [pickupTime, setPickupTime] = useState(new Date());
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [selectedDateSurcharge, setSelectedDateSurcharge] = useState(null);

    const restaurant = useSelector((state) => state.menu.restaurant);

    const handleRadioChange = (event) => {
        setPickupTimeType(event.target.value);
        pickupTimeTypeHandler(event.target.value);
    };

    const updateSelectedDateTime = () => {
      
    }

    const handleDateChange = (date) => {
         console.log('date', date);
        setSelectedDate(date);
        selectedDateHandler(date);
        const surcharge = checkHolidaySurcharge(date);
        //console.log('surcharge', surcharge);
        if (surcharge) {
            setSelectedDateSurcharge(surcharge);
        } else {
            setSelectedDateSurcharge(null);
        }
    };

    const handlePickupChange = (time) => {
        console.log('pickupTime', time);
        const formattedTime = moment(time).format("HH:mm");
        setPickupTime(time);
        pickupTimeHandler(formattedTime);

    };


  
      const checkHolidaySurcharge = (date) => {
        if (!restaurant || !restaurant.holidaySurchargeSettings) {
            return null;
        }
        const holidaySurcharge = restaurant.holidaySurchargeSettings;
       // console.log('holidaySurcharge', holidaySurcharge);
        if (holidaySurcharge.isEnabled === true && checkWeekdaysAndPublicHolidays(moment(date), holidaySurcharge)) {
            return {
                isEnabled: true,
                isPercentage: holidaySurcharge.isPercentage,
                amount: holidaySurcharge.amount
            }
        } else {
            return null;
        }
    };    


  const checkWeekdaysAndPublicHolidays = (today, holidaySurcharge) => {
    const uppercaseWeekdays = holidaySurcharge.weekdays.map((weekday) => weekday.toUpperCase());
    const todayWeekday = today.locale('au').format("dddd").toUpperCase()
    console.log('todayWeekday', todayWeekday);
    if (uppercaseWeekdays.includes(todayWeekday)) {
        return true;
    }

    const todayString = today.format("DD/MM/YYYY");
    if (holidaySurcharge.publicHolidayDays.includes(todayString)) {
        return true;
    }
    return false;
}


    return (
        <React.Fragment>
            <Grid item md={6} xs={12}>
                <FormControl component="fieldset" fullWidth>
                    <FormLabel component="legend" sx={{ fontSize: '0.875rem', marginBottom: '4px' }}>
                        Choose time
                    </FormLabel>
                    <RadioGroup
                        row
                        aria-label="position"
                        name="position"
                        defaultValue="now"
                        onChange={handleRadioChange}
                        sx={{ marginTop: '4px' }}
                    >
                        <FormControlLabel
                            value="now"
                            control={<Radio color="primary" size="small" />}
                            label={<Typography variant="body2">Now</Typography>}
                            sx={{ marginRight: '16px' }}
                        />
                        <FormControlLabel
                            value="chooseTime"
                            control={<Radio color="primary" size="small" />}
                            label={<Typography variant="body2">Choose time</Typography>}
                        />
                    </RadioGroup>
                </FormControl>
            </Grid>
            {pickupTimeType === "chooseTime" ? (
                <>
                    <Grid item lg={3} sm={6} xl={3} xs={12}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <TimePicker
                                label="Choose Time"
                                value={pickupTime}
                                onChange={(time) => handlePickupChange(time)}
                                ampm={false}
                                format="HH:mm"
                                slotProps={{
                                    textField: {
                                        size: "small",
                                        fullWidth: true,
                                        margin: "none"
                                    }
                                }}
                            />
                        </LocalizationProvider>
                    </Grid>
                    {restaurant && !restaurant.orderAheadDisabled ?
                        <Grid item lg={3} sm={6} xl={3} xs={12}>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <DatePicker
                                    format="dd/MM/yyyy"
                                    label="Choose Date"
                                    value={selectedDate}
                                    onChange={handleDateChange}
                                    slotProps={{
                                        textField: {
                                            size: "small",
                                            fullWidth: true,
                                            margin: "none"
                                        }
                                    }}
                                />
                            </LocalizationProvider>

                            {selectedDateSurcharge &&  selectedDateSurcharge.isEnabled === true ?
                                <Paper sx={{ marginTop: '8px' }}>
                                    <Alert severity="info" sx={{ padding: '6px 12px' }}>
                                        <AlertTitle sx={{ fontSize: '0.875rem', marginBottom: '2px' }}>Info</AlertTitle>
                                        <Typography variant="body2">
                                            <strong>Holiday surcharge of {`${selectedDateSurcharge.amount}${selectedDateSurcharge.isPercentage === true ? '% ': 'dollars '} will be added to all bills.`}</strong>
                                        </Typography>
                                    </Alert>
                                </Paper> : null  
                            }
                        </Grid>
                        : null}
                </>
            ) : null}
        </React.Fragment>
    );
}

export default OrderDateTime;